import { type Activity } from "@bentolabs/statistics-worker";
import { useChainId } from "wagmi";

import { bentoUSDConfig } from "shared/config/const";
import { tokensMeta } from "shared/config/tokens";
import { Img } from "shared/ui/img";
import { getBlockExplorerLink } from "shared/web3/utils/get-block-explorer-link";

type Props = {
  activity: Activity;
};

export const Row = (props: Props) => {
  const { activity } = props;
  const chainId = useChainId();

  const meta = tokensMeta[activity.token.symbol];
  const symbol =
    activity.token.symbol === "BORING"
      ? bentoUSDConfig[chainId].symbol
      : activity.token.symbol;
  const txLink = `${getBlockExplorerLink(chainId)}/tx/${activity.tx}`;

  return (
    <a
      target="_blank"
      href={txLink}
      referrerPolicy="no-referrer"
      className="transition-colors hover:brightness-125"
    >
      <li className="bg-baltic-sea/30 flex justify-between rounded-[10px] p-3.5">
        <div className="flex items-center gap-x-3.5">
          <Img className="size-9" src={meta?.logoURI} alt={symbol} />
          <div className="flex flex-col">
            <div className="leading-none capitalize">{activity.tp}</div>
            <div className="text-nobel/70 mt-1 text-sm leading-none">
              {symbol}
            </div>
          </div>
        </div>

        <div className="flex flex-col">
          <div>
            {/* {mainSign} */}
            {activity.amount} {symbol}
          </div>
          <div className="text-nobel/70 text-sm">
            {/* {secondarySign} */}
            {/* {secondaryValue} {secondaryCurrency?.symbol} */}
          </div>
        </div>
      </li>
    </a>
  );
};
